import * as Config from '../../../../../config';
import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import dayjs from 'dayjs';

import GridGenres from '../../../content/grid/GridGenres';

import useCustomGenres from '../hooks/useCustomGenres';

function ConnectedGenresManager({ url, id, name, dimension }) {
  const { width } = dimension;
  const { formatTitle, getMainGenre, isUpdated, getPlaylistsOpenFormatByID } = useCustomGenres();
  const isOpenFormat = [102,103,104,105,106,107,108,109].includes(id); //FORCE
  const playlistsNameOpenFormat = getPlaylistsOpenFormatByID(id);

  const customOrderFilter = (base, x, i) => {
    // const periodEnd = dayjs().format(`YYYY-MM`);
    const year = dayjs().format(`YYYY`);
    const lastYear = year - 1;
    let mainGenre = getMainGenre(x.genres, x.slug);

    if (mainGenre) {
      if (x.name && x.name.toLowerCase().includes('independent') && x.publish_date && x.publish_date.includes(year))  {
        const formatData = formatTitle(x);
        formatData.category = `${formatData.name} ${mainGenre.name}`;
        if (!base.some( y => y.name === formatData.name)) {
          formatData.isUpdated = isUpdated(formatData.category, x.change_date)
          base.push(formatData);
        }
     } else if (x.name && x.name.toLowerCase().includes('best new') 
        && (mainGenre.id === id)
        && x.change_date && (x.change_date.includes(year) || x.change_date.includes(lastYear)) /*(x.change_date.includes(dayjs().subtract(30, 'day').format(`YYYY-MM`)) || x.change_date.includes(periodEnd))*/ ) {
          const formatData = formatTitle(x, true);
          formatData.category = `${formatData.name} ${mainGenre.name}`;
          if (!base.some( y => y.name === formatData.name)) {
            formatData.isUpdated = isUpdated(formatData.category, x.change_date)
            base.push(formatData);
          }
      } else if (x.name && x.name.toLowerCase().includes('shortlist')
        && (mainGenre.id === id)
        && x.change_date && (x.publish_date.includes(year) || x.publish_date.includes(lastYear)) /*(x.publish_date.includes(dayjs().subtract(30, 'day').format(`YYYY-MM`)) || x.publish_date.includes(dayjs().subtract(60, 'day').format(`YYYY-MM`)) || x.publish_date.includes(periodEnd))*/) {
          const formatData = formatTitle(x, true);
          formatData.category = `${formatData.name} ${mainGenre.name}`;
          formatData.name = 'The ' + formatData.name;
          if (!base.some( y => y.name.includes(formatData.name))) {
            formatData.isUpdated = isUpdated(formatData.category, x.change_date)
            base.push(formatData);
          }
      } else if (x.name && x.name.toLowerCase().includes('floor essen') 
        && (mainGenre.id === id)
        && x.change_date && (x.change_date.includes(year) || x.change_date.includes(lastYear))) {
          const formatData = formatTitle(x);
          formatData.category = `${formatData.name} ${mainGenre.name}`;
          formatData.name = 'Dancefloor Essentials';
          if (!base.some( y => y.name.includes(formatData.name))) {
            formatData.isUpdated = isUpdated(formatData.category, x.change_date)
            base.push(formatData);
          }
      } else if (x.name && x.name.toLowerCase().includes('closing essen') 
        && (mainGenre.id === id)
        && x.change_date && (x.change_date.includes(year) || x.change_date.includes(lastYear))) {
          const formatData = formatTitle(x);
          formatData.category = `${formatData.name} ${mainGenre.name}`;
          if (!base.some( y => y.name.includes(formatData.name))) {
            formatData.isUpdated = isUpdated(formatData.category, x.change_date)
            base.push(formatData);
          }
      } else if (x.name && x.name.toLowerCase().includes('after hour') 
        && (mainGenre.id === id)
        && x.change_date && (x.change_date.includes(year) || x.change_date.includes(lastYear))) {
          const formatData = formatTitle(x);
          formatData.category = `${formatData.name} ${mainGenre.name}`;
          formatData.name = 'After Hours Essentials';
          if (!base.some( y => y.name.includes(formatData.name))) {
            formatData.isUpdated = isUpdated(formatData.category, x.change_date)
            base.push(formatData);
          }
      } else if (x.name && x.name.toLowerCase().includes('crate') 
        && (mainGenre.id === id)
        && x.publish_date && (x.publish_date.includes(year) || x.publish_date.includes(lastYear))) {
          const formatData = formatTitle(x);
          formatData.category = `${formatData.name} ${mainGenre.name}`;
          if (!base.some( y => y.name.includes(formatData.name))) {
            formatData.isUpdated = isUpdated(formatData.category, x.change_date)
            base.push(formatData);
          }
      } else if (x.name && x.name.toLowerCase().includes('secret') 
        && (mainGenre.id === id)
        && x.publish_date && (x.publish_date.includes(year) || x.publish_date.includes(lastYear))) {
          const formatData = formatTitle(x);
          formatData.category = `${formatData.name} ${mainGenre.name}`;
          if (!base.some( y => y.name.includes(formatData.name))) {
            formatData.isUpdated = isUpdated(formatData.category, x.change_date)
            base.push(formatData);
          }
      }
    } else {
      if (x.name && x.name.toLowerCase().includes('independent') && x.publish_date && (x.publish_date.includes(year) || x.publish_date.includes(lastYear))) {
        const formatData = formatTitle(x);
        formatData.category = `${formatData.name}`;
        if (!base.some( y => y.name.includes(formatData.name))) {
          formatData.isUpdated = isUpdated(formatData.category, x.change_date)
          base.push(formatData);
        }
      }
    }
    return base;
  }

  const customOpenFormat = (base, x, i) => {
    x.category = playlistsNameOpenFormat.find(name => !x.name.toLowerCase().includes('audio') && x.name.toLowerCase().includes(name.toLowerCase())) // x.slug;
    if (x.category) {
      const lastAddedIndex = base.findIndex( y => y.category?.toLowerCase() === x.category?.toLowerCase())
      const lastAdded = base[lastAddedIndex];
      if (!lastAdded) {
        x.isUpdated = isUpdated(x.category, x.change_date);
        base.push(x);
      } else if (dayjs(x.change_date).isAfter(dayjs(lastAdded.change_date))) {
        x.isUpdated = isUpdated(x.category, x.change_date);
        base[lastAddedIndex] = x;
      }
    }
    if (playlistsNameOpenFormat) {
      base.sort((a, b) => {
        const indexA = playlistsNameOpenFormat.indexOf(a.category);
        const indexB = playlistsNameOpenFormat.indexOf(b.category);
        if (indexA === -1 && indexB === -1) return 0;
        if (indexA === -1) return 1;
        if (indexB === -1) return -1;
        return indexA - indexB;
      });
    }
    return base;
  }

  return (
    <>
      { !isOpenFormat 
        ? <GridGenres title={`Playlists`} id={`{B}beatport_playlists_slice_${name}`}
        width={ width /*- Config.SUB_SIDEBAR*/ } rowCount={1} height={Config.CARD_HEIGHT + (Config.GRID_PAD * 2)} rowHeight={Config.CARD_HEIGHT + (Config.GRID_PAD * 2)}
        hasPagination={false} allTo={`${url}/playlists`} allLabel={`View All Playlists`}
        pathApi={`/v4/catalog/charts/?enabled=true&is_published=true&per_page=100&dj_id=36047&genre_id=${id}&name=best new,shortlist,floor,closing,after hour,independent,crate,secret&updated=${dayjs().subtract(1, 'year').format(`YYYY-MM-DD`)}:`}
        className={`grid-chart`} customReduceFormat={customOrderFilter} showLoading={true} showTitle={true} />
        : <GridGenres title={`Playlists`} id={`{B}beatport_playlists_slice_${name}`}
        width={ width /*- Config.SUB_SIDEBAR*/ } rowCount={1} height={Config.CARD_HEIGHT + (Config.GRID_PAD * 2)} rowHeight={Config.CARD_HEIGHT + (Config.GRID_PAD * 2)}
        hasPagination={true} hasPaginationV2={false} arrowLeftStyle={{ /*marginTop: -70*/ }} arrowRightStyle={{ /*marginTop: -70*/ }}
        pathApi={`/v4/catalog/charts/?enabled=true&is_published=true&per_page=100&genre_id=${id}&name=${encodeURIComponent(playlistsNameOpenFormat.join(','))}`}
        className={`grid-chart`} customReduceFormat={customOpenFormat} showLoading={true} showTitle={true} />
      }
    </>
  );
}

ConnectedGenresManager.propTypes = {
  url: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired
}

const GenresManager = connect(
  state => ({
    dimension: state.dimension
  })
)(ConnectedGenresManager);

export default GenresManager;
